"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customValueComponentsRegistry = void 0;
/**
 * Components registered as new input types with the handler for the new case. This makes the value extendable.
 */
exports.customValueComponentsRegistry = {};
